import {
  LANGUAGE_KEY,
  isSupportedLanguage,
  resolveLanguageRoute,
} from "./src/utils/languageRouting";

const readStorage = (storageName) => {
  try {
    const storage = window[storageName];
    const language = storage?.getItem(LANGUAGE_KEY);
    return isSupportedLanguage(language) ? language : null;
  } catch (error) {
    return null;
  }
};

const readCookie = () => {
  try {
    const languageCookie = document.cookie
      .split(";")
      .map((cookie) => cookie.trim())
      .find((cookie) => cookie.startsWith(`${LANGUAGE_KEY}=`));
    const language = languageCookie?.split("=")[1];

    return isSupportedLanguage(language) ? language : null;
  } catch (error) {
    return null;
  }
};

const getStoredLanguage = () =>
  readStorage("localStorage") ||
  readCookie() ||
  readStorage("sessionStorage");

const persistLanguage = (language) => {
  ["localStorage", "sessionStorage"].forEach((storageName) => {
    try {
      const storage = window[storageName];
      storage?.setItem(LANGUAGE_KEY, language);
    } catch (error) {
      // Storage can be unavailable in privacy modes; the cookie remains a fallback.
    }
  });

  try {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${LANGUAGE_KEY}=${language}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`;
  } catch (error) {
    // The local and session storage values are enough if cookies are blocked.
  }
};

const applyLanguageRoute = (location = window.location) => {
  const browserLanguages = navigator.languages || [navigator.language];
  const route = resolveLanguageRoute({
    pathname: location.pathname,
    storedLanguage: getStoredLanguage(),
    browserLanguages,
  });

  persistLanguage(route.language);

  if (route.pathname === location.pathname) {
    return;
  }

  const newUrl = new URL(window.location.href);
  newUrl.pathname = route.pathname;
  newUrl.search = location.search || "";
  newUrl.hash = location.hash || "";
  window.location.replace(newUrl.toString());
};

export const onClientEntry = () => {
  if (typeof window === "undefined") {
    return;
  }

  // Speed up AnchorLink scroll animation across the site.
  window.gatsby_scroll_duration = 350;
  applyLanguageRoute();
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined") {
    applyLanguageRoute(location);
  }
};
